import {
  integerFormatter,
    numberFormatter,
    percentageBarFormatter,
} from "../../gridFormatters";
import { wtPctAvg } from "../../math";

export const storageOverUtil = [
    {
      "field": "source",
      "headerName": "Source",
      "enableRowGroup": true,
      "filter": "agSetColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      }
    },
    {
      "field": "device_name",
      "headerName": "Array Name",
      "enableRowGroup": true,
      "filter": "agSetColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      }
    },
    {
      "field": "category",
      "headerName": "Category",
      "enableRowGroup": true,
      "filter": "agSetColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      }
    },
    {
      "field": "application",
      "headerName": "Application",
      "enableRowGroup": true,
      "filter": "agSetColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      }
    },
    {
      "field": "device_type",
      "headerName": "Device Type",
      "enableRowGroup": true,
      "filter": "agSetColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      }
    },
    {
      "field": "resource_name",
      "headerName": "Source Name",
      "enableRowGroup": true,
      "filter": "agSetColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      }
    },
    {
      "field": "util_pct",
      "type": "numericColumn",
      "cellStyle": {
        "text-align": "right"
      },
      "filter": "agNumberColumnFilter",
      "headerName": "Utilization %",
      "cellRenderer": percentageBarFormatter,
      "aggFunc": p => wtPctAvg(p, "used", "usable")
    },
    {
      "field": "used",
      "headerName": "Used ",
      "type": "numericColumn",
      "filter": "agNumberColumnFilter",
      "cellRenderer": numberFormatter
    },
    {
      "field": "usable",
      "headerName": "Usable ",
      "type": "numericColumn",
      "filter": "agNumberColumnFilter",
      "cellRenderer": numberFormatter
    },
    {
      "field": "allocated",
      "headerName": "Allocated ",
      "type": "numericColumn",
      "filter": "agNumberColumnFilter",
      "cellRenderer": numberFormatter
    },
    {
      "field": "allocated_pct",
      "headerName": "Allocated %",
      "type": "numericColumn",
      "filter": "agNumberColumnFilter",
      "cellRenderer": percentageBarFormatter,
      "aggFunc": p => wtPctAvg(p, "allocated", "usable")
    },
    {
      "field": "collection_date",
      "headerName": "Collection Date",
      "cellRenderer": "dateOnlyFormatter",
      "hide": true,
    },
    {
      "field": "mfg",
      "headerName": "Vendor",
      "enableRowGroup": true,
      "hide": true,
      "filter": "agSetColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      }
    },
    {
      "field": "data_center",
      "headerName": "Data Center",
      "enableRowGroup": true,
      "hide": true,
      "filter": "agSetColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      }
    },
    {
      "field": "classification",
      "headerName": "Classification",
      "enableRowGroup": true,
      "hide": true,
      "filter": "agSetColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      }
    }
];

export const storageOverProvisioned = [
    {
      "field": "source",
      "headerName": "Source",
      "enableRowGroup": true,
      "filter": "agSetColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      }
    },
    {
      "field": "device_name",
      "headerName": "Array Name",
      "enableRowGroup": true,
      "filter": "agSetColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      },
    },
    {
      "field": "device_type",
      "headerName": "Device Type",
      "enableRowGroup": true
    },
    {
      "field": "classification",
      "headerName": "Classification",
      "enableRowGroup": true
    },
    {
      "field": "resource_name",
      "headerName": "Source Name",
      "enableRowGroup": true,
      "filter": "agSetColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      }
    },
    {
      "field": "datacenter",
      "headerName": "Data Center",
      "enableRowGroup": true,
      "filter": "agSetColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      },
    },
    {
      "field": "allocated",
      "headerName": "Allocated",
      "type": "numericColumn",
      "filter": "agNumberColumnFilter",
      "cellRenderer": numberFormatter,
    },
    {
      "field": "allocated_pct",
      "headerName": "Allocated %",
      "type": "numericColumn",
      "filter": "agNumberColumnFilter",
      "cellRenderer": percentageBarFormatter,
      "aggFunc": p => wtPctAvg(p, "allocated", "usable")

    },
    {
      "field": "usable",
      "filter": "agNumberColumnFilter",
      "headerName": "Usable ",
      "type": "numericColumn",
      "cellRenderer": numberFormatter
    },
    {
      "field": "used",
      "filter": "agNumberColumnFilter",
      "headerName": "Used ",
      "type": "numericColumn",
      "cellRenderer": numberFormatter
    },
];

export const serversNearThresh = [
    {
      "field": "server_name",
      "headerName": "Server Name",
      "filter": "agSetColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      }
    },
    {
      "field": "server_type",
      "headerName": "Type of Server",
      "filter": "agSetColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      }
    },
    {
      "field": "num_cpus",
      "headerName": "# CPUs",
      "type": "numericColumn",
      "filter": "agNumberColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      },
      "cellRenderer": integerFormatter
    },
    {
      "field": "memory",
      "headerName": "Memory (MB)",
      "type": "numericColumn",
      "filter": "agNumberColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      },
      "cellRenderer": numberFormatter,
    },
    {
      "field": "allocated",
      "headerName": "Disk Allocated",
      "type": "numericColumn",
      "filter": "agNumberColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      },
      "cellRenderer": numberFormatter,
    },
    {
      "field": "cpu_util",
      "headerName": "CPU Util %",
      "type": "numericColumn",
      "filter": "agNumberColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      },
      "cellRenderer": percentageBarFormatter
    },
    {
      "field": "memory_util",
      "headerName": "Memory Util %",
      "type": "numericColumn",
      "filter": "agNumberColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      },
      "cellRenderer": percentageBarFormatter
    },
    {
      "field": "disk_util",
      "headerName": "Disk Util %",
      "type": "numericColumn",
      "filter": "agNumberColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      },
      "cellRenderer": percentageBarFormatter
    },
    {
      "field": "device_name",
      "headerName": "Device Name"
    },
    {
      "field": "cluster_name",
      "headerName": "Cluster Name"
    },
    {
      "field": "application",
      "headerName": "Application",
    }
];

export const serversOverThresh = [
    {
      "field": "server_name",
      "headerName": "Server Name",
      "filter": "agSetColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      }
    },
    {
      "field": "server_type",
      "headerName": "Type of Server",
      "filter": "agSetColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      }
    },
    {
      "field": "num_cpus",
      "headerName": "# CPUs",
      "type": "numericColumn",
      "filter": "agNumberColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      },
      "cellRenderer": integerFormatter
    },
    {
      "field": "memory",
      "headerName": "Memory (MB)",
      "type": "numericColumn",
      "filter": "agNumberColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      },
      "cellRenderer": numberFormatter
    },
    {
      "field": "allocated",
      "headerName": "Disk Allocated",
      "type": "numericColumn",
      "filter": "agNumberColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      },
      "cellRenderer": numberFormatter
    },
    {
      "field": "cpu_util",
      "headerName": "CPU Util %",
      "cellRenderer": percentageBarFormatter,
      "filter": "agNumberColumnFilter",
      "aggFunc": "avg",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      }
    },
    {
      "field": "memory_util",
      "headerName": "Memory Util %",
      "cellRenderer": percentageBarFormatter,
      "filter": "agNumberColumnFilter",
      "aggFunc": "avg",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      }
    },
    {
      "field": "disk_util",
      "headerName": "Disk Util %",
      "cellRenderer": percentageBarFormatter,
      "filter": "agNumberColumnFilter",
      "aggFunc": "avg",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      }
    },
    {
      "field": "device_name",
      "headerName": "Storage Array"
    },
    {
      "field": "cluster_name",
      "headerName": "Cluster Name",
      "filter": "agSetColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      }
    },
    {
      "field": "esx_host_name",
      "headerName": "Host Name",
      "filter": "agSetColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      }
    },
    {
      "field": "application",
      "headerName": "Application",
      "filter": "agSetColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      }
    }
];

export const clustersOverCap = [
    {
      "field": "cluster_name",
      "headerName": "Cluster Name",
      "enableRowGroup": true,
      "filter": "agSetColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      }
    },
    {
      "field": "vcenter_name",
      "headerName": "vCenter Name",
      "enableRowGroup": true,
      "filter": "agSetColumnFilter",
      "filterParams": {
        "cellHeight": 20,
        "debounceMs": 1000
      }
    },
    {
      "field": "vm_build_capacity",
      "headerName": "Build Capacity (VM)",
      "type": "numericColumn",
      "filter": "agNumberColumnFilter",
      "cellRenderer": numberFormatter
    },
    {
      "field": "vm_cpu_build_capacity",
      "headerName": "CPU Build Capacity (VM)",
      "type": "numericColumn",
      "filter": "agNumberColumnFilter",
      "cellRenderer": numberFormatter
    },
    {
      "field": "vm_mem_build_capacity",
      "headerName": "Memory Build Capacity (VM)",
      "type": "numericColumn",
      "filter": "agNumberColumnFilter",
      "cellRenderer": numberFormatter
    },
    {
      "field": "vm_disk_build_capacity",
      "headerName": "Disk Build Capacity (VM)",
      "type": "numericColumn",
      "filter": "agNumberColumnFilter",
      "cellRenderer": numberFormatter
    }
];